import {
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  type DialogActionsProps as MuiDialogActionsProps,
  DialogContent as MuiDialogContent,
  type DialogContentProps as MuiDialogContentProps,
  DialogContentText as MuiDialogContentText,
  type DialogContentTextProps as MuiDialogContentTextProps,
  type DialogProps as MuiDialogProps,
  DialogTitle as MuiDialogTitle,
  type DialogTitleProps as MuiDialogTitleProps,
  IconButton,
  styled,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export type DialogProps = MuiDialogProps;
export type DialogActionsProps = MuiDialogActionsProps;
export type DialogContentProps = MuiDialogContentProps;
export type DialogContentTextProps = MuiDialogContentTextProps;
export type DialogTitleProps = MuiDialogTitleProps;

export const Dialog = MuiDialog;
export const DialogActions = MuiDialogActions;
export const DialogContent = MuiDialogContent;
export const DialogContentText = MuiDialogContentText;
export const DialogTitle = MuiDialogTitle;

export const DialogHeader = styled((props: JSX.IntrinsicElements["div"] & { onClose?: () => void }) => {
  const { onClose, children, ...rest } = props;
  return (
    <div {...rest}>
      <div>{children}</div>
      {onClose && (
        <IconButton variant="contained" color={"secondary"} size={"tiny"} onClick={onClose}>
          <CloseRoundedIcon />
        </IconButton>
      )}
    </div>
  );
})({
  display: "grid",
  gridTemplateColumns: "1fr auto",
  alignItems: "center",
  padding: "24px 24px 0 24px",
});
